export default "__VITE_ASSET__9cf510b5__"